import { Elements, RecurlyProvider } from "@recurly/react-recurly";
import { inject } from "mobx-react";
import type { Store } from "../../../../../../../client/stores";
import { Remote } from "../../../../../../core/components/remote/Remote.component";
import { Button, ButtonKind } from "../../../../../../core/ui";
import { recurlyLoader } from "../../../../lib/recurly";
import { CoastAlertDisplayError } from "../../common/coast-alert/CoastAlertDisplay.component";
import { CoastUserUpdateBillingInfo, CoastUserUpdateBillingInfoProps } from "./CoastUserUpdateBillingInfo.component";

interface CoastUserBillingInfoWrapperProps extends CoastUserUpdateBillingInfoProps {
    store?: Store;
}

export const CoastUserBillingInfoWrapper = inject("store")(({ store, ...props }: CoastUserBillingInfoWrapperProps) => {
    if (!store?.env.COAST_RECURLY_PUBLIC_KEY) {
        return null;
    }

    return (
        <div className="component-billingInfo-wrapper">
            <Remote loader={recurlyLoader} cacheKey={"recurly-lib"} showLoading={true}>
                {({ data }) =>
                    data ? (
                        <RecurlyProvider publicKey={store.env.COAST_RECURLY_PUBLIC_KEY}>
                            <Elements>
                                <CoastUserUpdateBillingInfo {...props} />
                            </Elements>
                        </RecurlyProvider>
                    ) : (
                        <div>
                            <Button
                                className="button-back-to-account"
                                kind={ButtonKind.CUSTOMIZED}
                                click={() => props.goBack()}
                            >
                                Back
                            </Button>
                            <CoastAlertDisplayError isDisplayed={true} />
                        </div>
                    )
                }
            </Remote>
        </div>
    );
});
